/*接口域名的管理*/
const base = {
  url:'',
}

export default base;